import { forwardRef, type InputHTMLAttributes } from "react";

export const TextField = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function TextField({ className = "", ...props }, ref) {
    return (
      <input ref={ref} className={["text-field", className].filter(Boolean).join(" ")} {...props} />
    );
  },
);
